export default __webpack_public_path__ + "media/thoughtOftheDay-Icon.2db8a727.svg";